"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
exports.__esModule = true;
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var MetricsSection = /** @class */ (function () {
    function MetricsSection() {
    }
    MetricsSection.prototype.onLoadEach = function ($element) {
        var $cardSpan = $element.$("[data-count-up]");
        var formatNumber = function (num) { return new Intl.NumberFormat("it-IT").format(num); };
        var _a = $cardSpan.dataset, _b = _a.counterInitial, counterInitial = _b === void 0 ? 0 : _b, _c = _a.counterFinal, counterFinal = _c === void 0 ? 100 : _c, _d = _a.counterSpeed, counterSpeed = _d === void 0 ? 1000 : _d;
        var startingValue = Number(counterInitial);
        var endingValue = Number(counterFinal);
        var speed = Number(counterSpeed);
        var frameDuration = 1000 / 60;
        if (!endingValue) {
            return;
        }
        var getIncreaseCounter$ = function () {
            var difference = endingValue - startingValue;
            return (0, rxjs_1.timer)(0, frameDuration).pipe((0, operators_1.map)(function (n) { return n * frameDuration; }), (0, operators_1.takeWhile)(function (n) { return n < speed; }), (0, operators_1.throttleTime)(0, rxjs_1.animationFrameScheduler), (0, operators_1.map)(function (n) { return (startingValue + (n / speed) * difference).toFixed(0); }));
        };
        var intersectionOptions = {
            root: null,
            rootMargin: "0px",
            threshold: 0.7
        };
        var intersection = new IntersectionObserver(function (entries) {
            entries.map(function (entry) {
                if (entry.isIntersecting) {
                    var setValue_1 = function (value) {
                        return ($cardSpan.innerHTML = "".concat(formatNumber(value)));
                    };
                    getIncreaseCounter$().subscribe(setValue_1, function () { return setValue_1(endingValue); }, function () { return setValue_1(endingValue); });
                    intersection.unobserve(entry.target);
                }
            });
        }, intersectionOptions);
        intersection.observe($element);
        (0, DOMScript_1.getRefreshEvent$)().subscribe(function () {
            intersection.observe($element);
        });
    };
    MetricsSection = __decorate([
        (0, DOMScript_1.DOMBlock)({
            selector: ".CardMetric",
            isElementArray: true
        })
    ], MetricsSection);
    return MetricsSection;
}());
new MetricsSection();
